import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme, { listStyleType, pl })=>({
        list: {
            fontSize: 'inherit',
            color: 'inherit',
            listStyleType: listStyleType,
            paddingLeft: theme.spacing(pl)
        }
    }));
const List_styles = useStyles;
export default List_styles;
